export default __webpack_public_path__ + "static/media/13.fcd647e4.jpg";